import React, { useState } from 'react';
import { FaTimes, FaInfinity, FaSave } from 'react-icons/fa';

const PlanLimitsEditModal = ({ plan, onSave, onCancel, isUpdating }) => {
  const [limits, setLimits] = useState({
    maxProjects: plan.limits.maxProjects,
    maxDocuments: plan.limits.maxDocuments,
    maxProductsPerProject: plan.limits.maxProductsPerProject,
    maxModulesPerProject: plan.limits.maxModulesPerProject,
    maxShortLinks: plan.limits.maxShortLinks,
    maxSupportModules: plan.limits.maxSupportModules,
    maxInternalAds: plan.limits.maxInternalAds,
    maxLandingPages: plan.limits.maxLandingPages
  });

  const [pricing, setPricing] = useState({
    monthly: plan.pricing.monthly,
    yearly: plan.pricing.yearly,
    currency: plan.pricing.currency
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(plan.plan, { limits, pricing });
  };

  const handleInputChange = (field, value) => {
    // Convert empty string or -1 to -1 (unlimited)
    const numValue = value === '' || value === '-1' ? -1 : parseInt(value, 10);
    setLimits(prev => ({
      ...prev,
      [field]: numValue
    }));
  };

  const handlePricingChange = (field, value) => {
    const numValue = parseFloat(value) || 0;
    setPricing(prev => ({
      ...prev,
      [field]: numValue
    }));
  };

  const getPlanLabel = (planValue) => {
    const labels = {
      'free': 'Ücretsiz',
      'premium': 'Premium',
      'enterprise': 'Enterprise'
    };
    return labels[planValue] || planValue;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-700">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-white">
              {getPlanLabel(plan.plan)} Plan Limitlerini Düzenle
            </h2>
            <button
              onClick={onCancel}
              className="text-gray-400 hover:text-white"
              disabled={isUpdating}
            >
              <FaTimes className="h-6 w-6" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="space-y-6">
            <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-4">
              <p className="text-sm text-blue-300 flex items-center">
                <FaInfinity className="mr-2" />
                <span>Sınırsız için -1 girin veya alanı boş bırakın</span>
              </p>
            </div>

            {/* Max Projects */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Maksimum Proje Sayısı
              </label>
              <input
                type="number"
                value={limits.maxProjects === -1 ? '' : limits.maxProjects}
                onChange={(e) => handleInputChange('maxProjects', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxProjects === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            {/* Max Documents */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Maksimum Döküman Sayısı
              </label>
              <input
                type="number"
                value={limits.maxDocuments === -1 ? '' : limits.maxDocuments}
                onChange={(e) => handleInputChange('maxDocuments', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxDocuments === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            {/* Max Products Per Project */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Proje Başına Maksimum Ürün Sayısı
              </label>
              <input
                type="number"
                value={limits.maxProductsPerProject === -1 ? '' : limits.maxProductsPerProject}
                onChange={(e) => handleInputChange('maxProductsPerProject', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxProductsPerProject === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            {/* Max Modules Per Project */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Proje Başına Maksimum Modül Sayısı
              </label>
              <input
                type="number"
                value={limits.maxModulesPerProject === -1 ? '' : limits.maxModulesPerProject}
                onChange={(e) => handleInputChange('maxModulesPerProject', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxModulesPerProject === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            {/* Max Short Links */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Maksimum Kısa Link Sayısı
              </label>
              <input
                type="number"
                value={limits.maxShortLinks === -1 ? '' : limits.maxShortLinks}
                onChange={(e) => handleInputChange('maxShortLinks', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxShortLinks === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            {/* Max Support Modules */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Maksimum Destek Modülü Sayısı
              </label>
              <input
                type="number"
                value={limits.maxSupportModules === -1 ? '' : limits.maxSupportModules}
                onChange={(e) => handleInputChange('maxSupportModules', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxSupportModules === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Maksimum Internal Ads Sayısı
              </label>
              <input
                type="number"
                value={limits.maxInternalAds === -1 ? '' : limits.maxInternalAds}
                onChange={(e) => handleInputChange('maxInternalAds', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxInternalAds === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Maksimum Landing Pages Sayısı
              </label>
              <input
                type="number"
                value={limits.maxLandingPages === -1 ? '' : limits.maxLandingPages}
                onChange={(e) => handleInputChange('maxLandingPages', e.target.value)}
                className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Sınırsız için boş bırakın"
                min="-1"
              />
              {limits.maxLandingPages === -1 && (
                <p className="mt-1 text-sm text-gray-400 flex items-center">
                  <FaInfinity className="mr-1" /> Sınırsız
                </p>
              )}
            </div>

            {/* Pricing Section */}
            <div className="border-t border-gray-700 pt-6">
              <h3 className="text-lg font-semibold text-white mb-4">Fiyatlandırma</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Monthly Price */}
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Aylık Fiyat ($)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={pricing.monthly}
                    onChange={(e) => handlePricingChange('monthly', e.target.value)}
                    className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    min="0"
                  />
                </div>

                {/* Yearly Price */}
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Yıllık Fiyat ($)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={pricing.yearly}
                    onChange={(e) => handlePricingChange('yearly', e.target.value)}
                    className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    min="0"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-3 mt-6 pt-6 border-t border-gray-700">
            <button
              type="button"
              onClick={onCancel}
              disabled={isUpdating}
              className="px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-50"
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={isUpdating}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center disabled:opacity-50"
            >
              {isUpdating ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Kaydediliyor...
                </>
              ) : (
                <>
                  <FaSave className="mr-2 h-4 w-4" />
                  Kaydet
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PlanLimitsEditModal;

